export const MAX_TEXT_LENGTH = 20_000;
export const MIN_TEXT_LENGTH = 40;
export const CLIENT_ANALYSIS_TIMEOUT_MS = 55_000;
export const WORKER_ANALYSIS_TIMEOUT_MS = 50_000;

export type InputValidation = {
  resumeError?: string;
  jobAdError?: string;
};

export function validateInputs(resume: string, jobAd: string): InputValidation {
  const errors: InputValidation = {};
  const cleanResume = resume.trim();
  const cleanJobAd = jobAd.trim();

  if (!cleanResume) errors.resumeError = 'Add your resume text to continue.';
  else if (cleanResume.length < MIN_TEXT_LENGTH) errors.resumeError = `Your resume needs a little more detail (at least ${MIN_TEXT_LENGTH} characters).`;
  else if (cleanResume.length > MAX_TEXT_LENGTH) errors.resumeError = `Your resume is too long. Keep it under ${MAX_TEXT_LENGTH.toLocaleString()} characters.`;

  if (!cleanJobAd) errors.jobAdError = 'Paste the job advertisement to continue.';
  else if (cleanJobAd.length < MIN_TEXT_LENGTH) errors.jobAdError = `The job ad needs a little more detail (at least ${MIN_TEXT_LENGTH} characters).`;
  else if (cleanJobAd.length > MAX_TEXT_LENGTH) errors.jobAdError = `The job ad is too long. Keep it under ${MAX_TEXT_LENGTH.toLocaleString()} characters.`;

  return errors;
}

export function isValidInput(validation: InputValidation): boolean {
  return !validation.resumeError && !validation.jobAdError;
}
